import React from 'react';
import { bool, number, oneOfType, shape, string } from 'prop-types';

import { Box, Stack, Typography } from '@mui/material';

import { ProductIndicatorBadge } from 'common';
import * as futureDrawerStyles from '../EditFutureSequenceDrawer.styles';

const HIDDEN_LOCATION_COMPANY_CODES = ['MPL', 'MTH'];

const ProductLocationInfo = ({
  dataCompany,
  innerSpacing,
  labelSx,
  labelVariant,
  location,
  pairSpacing,
  product,
  secondaryValueSx,
  secondaryValueVariant,
  valueSx,
  valueVariant,
}) => {
  const { nameLong: locationNameLong } = location || {};
  const { nameLong: productNameLong, proprietary } = product || {};
  const normalizedDataCompany = (dataCompany || '').trim().toUpperCase();
  const shouldDisplayDataCompany = !HIDDEN_LOCATION_COMPANY_CODES.includes(normalizedDataCompany);

  return (
    <>
      <Box sx={futureDrawerStyles.productLocationInfoContainerSx}>
        <Stack spacing={pairSpacing}>
          <Box>
            <Typography sx={labelSx} variant={labelVariant}>
              Product
            </Typography>
            <Box sx={futureDrawerStyles.productLocationInfoRowSx(innerSpacing)}>
              <Typography sx={valueSx} variant={valueVariant}>
                {productNameLong}
              </Typography>
              <ProductIndicatorBadge proprietary={proprietary} />
            </Box>
          </Box>
          <Box>
            <Typography sx={labelSx} variant={labelVariant}>
              Location
            </Typography>
            <Box sx={futureDrawerStyles.productLocationInfoRowSx(innerSpacing)}>
              <Typography sx={valueSx} variant={valueVariant}>
                {locationNameLong}
              </Typography>
              {shouldDisplayDataCompany && (
                <Typography sx={secondaryValueSx} variant={secondaryValueVariant}>
                  {dataCompany}
                </Typography>
              )}
            </Box>
          </Box>
        </Stack>
      </Box>
    </>
  );
};

export default ProductLocationInfo;

ProductLocationInfo.propTypes = {
  dataCompany: string.isRequired,
  innerSpacing: oneOfType([number, string]),
  labelSx: shape({}),
  labelVariant: string,
  location: shape({
    nameLong: string,
  }).isRequired,
  pairSpacing: number,
  product: shape({
    nameLong: string,
    proprietary: bool,
  }),
  secondaryValueSx: shape({}),
  secondaryValueVariant: string,
  valueSx: shape({}),
  valueVariant: string,
};

ProductLocationInfo.defaultProps = {
  innerSpacing: 1,
  labelSx: null,
  labelVariant: 'body1',
  pairSpacing: 2,
  product: {},
  secondaryValueSx: null,
  secondaryValueVariant: 'body2',
  valueSx: { color: 'text.primary' },
  valueVariant: 'subtitle1',
};
